<script lang="ts">
	import { format } from '../../../services/i18n';
	import {
		ActionsContainer,
		IconButton,
		ListMenuCard,
		ListMenuCardV2,
	} from '@Shelly/shelly-design-system/index';

	import { edit } from 'src/stores/ui/edit_lists';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import type { ISceneObj } from '../../../types/SceneType';
	import { mapLegacyColorToToken } from 'src/helpers/new-layout-helpers';

	import TimerAlarmDelay from './components/TimerAlarmDelay.svelte';
	import ControlAlarm from './ControlAlarm.svelte';
	import { updateItemStoreAfterPulse } from 'src/helpers/add-entity-helpers';

	export let item: any;
	export let load_image_from: (path: string) => string | undefined;
	export let onCardClick: (item: ISceneObj) => void;
	export let onCardDelete: (e: MouseEvent | TouchEvent, item: ISceneObj) => void;
	export let onCardEdit: (e: MouseEvent | TouchEvent, item: ISceneObj) => void;
	export let alarmsDelayModal: any;
	export let alarmsDelayTimer: any;

	$: if (item?._meta?.new && $edit) {
		// Remove pulse when added new item and we are in edit mode
		updateItemStoreAfterPulse(item, 'alarms');
	}
</script>

{#if $showNewLayout}
	<ListMenuCardV2
		title={item._meta.name}
		image={item._meta.image && load_image_from(item._meta.image)}
		backgroundColor={mapLegacyColorToToken(item._meta.backgroundColor)}
		editMode={$edit}
		selected={item.id === $sidePanelStateCombined?.id}
		size="small"
		isFocusable={false}
		type="compact"
		on:click={() => onCardClick(item)}
		on:handle-drag-start
		on:handle-drag-end
		pulseAnimation={item?._meta?.new}
		on:pulse-animation-end={() => {
			updateItemStoreAfterPulse(item, 'alarms');
		}}
	>
		<TimerAlarmDelay
			alarm={item}
			slot="main"
			bind:showModal={alarmsDelayModal[item.id]}
			bind:timer={alarmsDelayTimer[item.id]}
		/>

		<svelte:fragment slot="right">
			<ControlAlarm
				{item}
				on:alarmDelayStart={(e) => {
					alarmsDelayModal[item.id] = !!e.detail;
				}}
			/>
		</svelte:fragment>
	</ListMenuCardV2>
{:else}
	<ListMenuCard
		title={item._meta.name}
		image={item._meta.image && load_image_from(item._meta.image)}
		backgroundColor={item._meta.backgroundColor}
		editMode={$edit}
		selected={item.id === $sidePanelStateCombined?.id}
		on:click={() => onCardClick(item)}
		size="small"
		isFocusable={false}
		pulseAnimation={item?._meta?.new}
		on:pulse-animation-end={async () => {
			updateItemStoreAfterPulse(item, 'alarms');
		}}
	>
		<TimerAlarmDelay
			alarm={item}
			slot="main"
			bind:showModal={alarmsDelayModal[item.id]}
			bind:timer={alarmsDelayTimer[item.id]}
		/>

		<svelte:fragment slot="right">
			{#if $edit}
				<ActionsContainer orientation="horizontal">
					<IconButton
						aria-label={$format('button_drag_handle', {
							default: 'Button drag handle',
						})}
						on:mousedown
						on:touchstart
						on:mouseup
						on:touchend
						icon="fas fa-up-down-left-right"
						slot="first"
						dndHandle
					/>
					<IconButton
						aria-label={$format('button_edit_alarm', {
							default: 'Button edit alarm',
						})}
						icon="fas fa-pen"
						slot="second"
						on:click={(event) => onCardEdit(event, item)}
					/>
					<IconButton
						aria-label={$format('button_delete_alarm', {
							default: 'Button delete alarm',
						})}
						icon="fas fa-trash"
						variant="danger"
						slot="third"
						on:click={(event) => onCardDelete(event, item)}
					/>
				</ActionsContainer>
			{:else}
				<ControlAlarm
					{item}
					on:alarmDelayStart={(e) => {
						alarmsDelayModal[item.id] = !!e.detail;
					}}
				/>
			{/if}
		</svelte:fragment>
	</ListMenuCard>
{/if}
